import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { IBannerReducer, INotificationReducer } from '../interface'
import Banner from './Banner'
import Notification from './Notification'

interface IFairCarouselProps {
  items: IBannerReducer[] | INotificationReducer[]
}

export default function FairCarousel(props: IFairCarouselProps) {
  const { items } = props

  if (!items || items.length === 0) {
    return null
  }
  return (
    <Carousel
      infiniteLoop={items.length > 1} /*false if one slider, fixes touch scroll on mobile */
      showThumbs={false}
      autoPlay={true}
      showStatus={false}
      showIndicators={false}
      useKeyboardArrows={true}
      interval={6000}
      transitionTime={600}
    >
      {items.map((data, index) => {
        if (data.type === 'notification') {
          return <Notification key={index} data={data as INotificationReducer} />
        }

        return <Banner key={index} data={data as IBannerReducer} />
      })}
    </Carousel>
  )
}
